/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_TaglineInputs */

const en_login_tagline = /** @type {(inputs: Login_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your recipes, your week, your shopping list.`)
};

const de_login_tagline = /** @type {(inputs: Login_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Rezepte, deine Woche, deine Einkaufsliste.`)
};

/**
* | output |
* | --- |
* | "Your recipes, your week, your shopping list." |
*
* @param {Login_TaglineInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const login_tagline = /** @type {((inputs?: Login_TaglineInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_TaglineInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_login_tagline(inputs)
	return en_login_tagline(inputs)
});